/**
 * Layout Context
 * Manages page title and layout-related state
 */

import React, { createContext, useState, useContext } from 'react';

const LayoutContext = createContext();

export const useLayout = () => {
  const context = useContext(LayoutContext);
  if (!context) {
    throw new Error('useLayout must be used within a LayoutProvider');
  }
  return context;
};

export const LayoutProvider = ({ children }) => {
  const [pageTitle, setPageTitle] = useState('Dashboard');
  
  // Future extensions: pageActions, breadcrumbs, etc.
  
  return (
    <LayoutContext.Provider value={{ pageTitle, setPageTitle }}>
      {children}
    </LayoutContext.Provider>
  );
};

